var map = {
	"./TickSquare.svg": 6416,
	"./acc-created.svg": 3510,
	"./acc-not-verified.svg": 1766,
	"./account-active-icn.svg": 7627,
	"./account-icn.svg": 2974,
	"./acordion-minus-icn.svg": 1653,
	"./acordion-plus-icn.svg": 9565,
	"./active-bankdetails.svg": 7955,
	"./active-home.svg": 296,
	"./active-myprofile-hv-icn.svg": 2776,
	"./active-useragreement-hv-icn.svg": 4494,
	"./active-yourapplication-hv-icn.svg": 9732,
	"./add-btn-icn.svg": 2473,
	"./ae-icn.svg": 545,
	"./agent-coursefinder-hv-icn.svg": 6809,
	"./agent-home-hv-icn.svg": 663,
	"./agent-icn.svg": 2644,
	"./agent-students-connected-hv-icn.svg": 5194,
	"./agent-students-hv-icn.svg": 8328,
	"./agent_application-hv-icn.svg": 6340,
	"./agent_hv_icn.svg": 4765,
	"./agent_icn.svg": 7078,
	"./agreement.svg": 4626,
	"./american-ex-icn.png": 9099,
	"./app-dot-icn.svg": 5464,
	"./app-section-img2.png": 1025,
	"./application-green.svg": 1946,
	"./application-icn.svg": 1661,
	"./applicationnotify.svg": 787,
	"./applied-course-tick.svg": 1473,
	"./appstore copy.svg": 7601,
	"./appstore-btn.svg": 7349,
	"./appstore.svg": 4934,
	"./arrow-active.svg": 8800,
	"./arrow-right-circle.svg": 2137,
	"./arrow-right-white-circle.svg": 1401,
	"./arrow_down.svg": 6316,
	"./arrow_up.svg": 7303,
	"./attach-icn.svg": 9016,
	"./avatar.png": 4367,
	"./back-icn.svg": 9794,
	"./backgroundinformation-icn.svg": 7025,
	"./bank-icn.svg": 2673,
	"./bitmap.png": 3129,
	"./blue-arrow-right.svg": 1243,
	"./blue-cloud-sm.svg": 891,
	"./blue-cloud.svg": 3250,
	"./blue-shine-img.png": 4964,
	"./bolton-univ-logo.png": 2825,
	"./btn-img.svg": 2744,
	"./btn-spinner.gif": 9293,
	"./business-active-icn.svg": 6338,
	"./business-icn.svg": 8805,
	"./calendar-icn.svg": 6817,
	"./call-icon.png": 8692,
	"./cambridge-img.png": 834,
	"./cambridge-img.svg": 3310,
	"./cashback-icon.svg": 7816,
	"./cashback_icon_1.svg": 154,
	"./category-hv-icn.svg": 9520,
	"./category-icn.svg": 8475,
	"./checkbox-active.svg": 7600,
	"./chevron-right.svg": 4462,
	"./circle-arrow.svg": 2370,
	"./circle-blue-arrow.svg": 9651,
	"./close-icn.svg": 6575,
	"./close-red-icn.svg": 8165,
	"./cloud-img.png": 7403,
	"./comingsoon.png": 5212,
	"./complete-profile-tick-icn.svg": 194,
	"./completed-icn.svg": 2612,
	"./connect-to-agent-icn.svg": 6031,
	"./continue-icn.svg": 5128,
	"./course-oxford-university.svg": 9537,
	"./course-selection-icn.svg": 4541,
	"./course-selection-icn1.svg": 4550,
	"./coursefinder-icn.svg": 448,
	"./default-bankdetails.svg": 3346,
	"./del-icon-blue.svg": 3770,
	"./delete-confirmation-icn.svg": 2590,
	"./delete-icn-white.svg": 6746,
	"./delete-icn.svg": 5950,
	"./discover-icn.svg": 5526,
	"./doc-icn.svg": 3785,
	"./document-active-icn.svg": 1773,
	"./document-icn.svg": 4764,
	"./document1-icn.svg": 3371,
	"./documentsattach-icn.svg": 5322,
	"./double-circle-arrow.svg": 2606,
	"./down-arrow-old.svg": 7566,
	"./down-arrow-white.svg": 6846,
	"./down-arrow.svg": 9778,
	"./download-circle-button.svg": 5328,
	"./dummy-map.png": 6527,
	"./duration-icn.svg": 5599,
	"./edit-btn.svg": 3681,
	"./edu-tech-background.png": 648,
	"./educationhistory-icn.svg": 5981,
	"./edutech-loader.gif": 8531,
	"./edutech_footer_logo.svg": 8870,
	"./filter-icn.svg": 2153,
	"./food-for-life-img.png": 2817,
	"./generalinformation-icn.svg": 7865,
	"./googleplay .svg": 6775,
	"./googleplay.svg": 3885,
	"./harvard-img.png": 2748,
	"./header-logo.png": 9243,
	"./help-active-icn.svg": 5891,
	"./help-icn.svg": 726,
	"./home-banner.png": 6122,
	"./home-icn.svg": 8574,
	"./home.svg": 9156,
	"./iconly-bulk-info-square.svg": 358,
	"./iconly-dark-delete.svg": 2171,
	"./iconly-light-arrow-left.png": 911,
	"./iconly-light-delete.png": 1645,
	"./iconly-light-delete.svg": 5373,
	"./iconly-light-document.png": 2567,
	"./iconly-light-edit.png": 944,
	"./iconly-light-edit.svg": 2160,
	"./iconly-light-info-circle-white.svg": 4057,
	"./iconly-light-location.png": 9697,
	"./iconly-light-message.png": 5319,
	"./iconly-light-more-square.svg": 9357,
	"./iconly-light-outline-close-square.png": 2631,
	"./iconly-light-paper-upload.png": 3620,
	"./iconly-light-paper-upload.svg": 3896,
	"./iconly-light-plus.png": 1132,
	"./info-icn.svg": 7739,
	"./jcb-icn.svg": 4778,
	"./landing-page.png": 291,
	"./larrow.png": 1187,
	"./left-arrow.svg": 4313,
	"./level-icn.svg": 7005,
	"./location-icn.svg": 7394,
	"./logo-purple.svg": 5614,
	"./logo-web.svg": 1658,
	"./logo.png": 5549,
	"./logo.svg": 7503,
	"./logo_black.png": 6569,
	"./logout-icn.svg": 5513,
	"./logout.svg": 3292,
	"./london-metropoliton-img.png": 7559,
	"./maestro-icn.svg": 3852,
	"./mail-icon.png": 1439,
	"./master-card-icn.svg": 434,
	"./mastercard-icn.svg": 719,
	"./menu-btn-bg.png": 96,
	"./menu-btn-bg1.png": 5755,
	"./message-icn.svg": 6890,
	"./mit-img.png": 2150,
	"./modal-close-icn.svg": 6287,
	"./mode-icn.svg": 4250,
	"./more-course.svg": 3757,
	"./more-icn.svg": 5368,
	"./msg-icn.svg": 2884,
	"./network-issue.png": 106,
	"./no-data-found.png": 855,
	"./no-data.png": 8780,
	"./no_img.png": 4249,
	"./notification-bell.svg": 4031,
	"./notification-green.svg": 7229,
	"./notification-icn.svg": 1922,
	"./notify-active-icn.svg": 3405,
	"./notify-icn.svg": 5100,
	"./novelty-card.svg": 7608,
	"./option-icn-blue.svg": 5709,
	"./option-icn.svg": 3588,
	"./oxford-img.png": 8820,
	"./oxford-img1.png": 6231,
	"./oxford-university-icn.svg": 9236,
	"./oxford-university-icon.svg": 169,
	"./oxford.png": 4510,
	"./paper-dark-upload.svg": 2437,
	"./paper-icn.svg": 4177,
	"./paper-upload.svg": 4554,
	"./password_hide.svg": 2608,
	"./password_show.svg": 7811,
	"./payment-active-icn.svg": 8498,
	"./payment-icn.svg": 4981,
	"./payment-tick-icn.svg": 5263,
	"./pickauni-logo-dark.png": 5523,
	"./pickauni-logo-white.png": 5504,
	"./playstore-btn.svg": 6120,
	"./plus-icn-blue.svg": 380,
	"./plus-icn.svg": 8775,
	"./plus-sign.svg": 8432,
	"./profile-green.svg": 4939,
	"./profile-icn.svg": 6732,
	"./profile-image.png": 697,
	"./promo-apply-img.png": 4938,
	"./promocode_hv_icn.svg": 8410,
	"./promocode_icn.svg": 9235,
	"./promoter-signin-bg.svg": 6573,
	"./promotion-icn-green.svg": 5850,
	"./pwd-active-icn.svg": 3443,
	"./pwd-icn.svg": 2486,
	"./rarrow.png": 1369,
	"./red_tick.svg": 2525,
	"./reference-active-icn.svg": 4821,
	"./reference-icn.svg": 4996,
	"./right-arrow-blue-icn.svg": 2876,
	"./right-arrow-green-icn.svg": 6875,
	"./right-arrow-white-icn.svg": 7537,
	"./right-arrow.svg": 2916,
	"./right-connect-now-icn.svg": 4131,
	"./rounded-circle.svg": 302,
	"./scroll-down.svg": 6326,
	"./search-blue-icn.svg": 3534,
	"./search-blue-icon.svg": 5691,
	"./search-icn.png": 8633,
	"./search-icn.svg": 9227,
	"./select-close-icn.svg": 9936,
	"./sigin-dwn-arrow.svg": 736,
	"./signup-img.png": 1042,
	"./signup-img1.png": 6993,
	"./slick-left-arrow.svg": 5436,
	"./slick-right-arrow.svg": 7875,
	"./slider-arrow.svg": 2505,
	"./slider/novelty01.jpg": 2456,
	"./slider/novelty02.jpg": 1127,
	"./slider/pick-a-uni01.jpg": 9933,
	"./slider/pick-a-uni02.png": 8086,
	"./slider/slider-img1.png": 404,
	"./slider/slider-img2.png": 5055,
	"./slider/slider-img3.png": 8726,
	"./slider/slider-img4.png": 8553,
	"./slider/slider-img5.png": 3728,
	"./slider/slider1.jpg": 3958,
	"./slider/slider2.jpg": 4305,
	"./slider/slider3.jpg": 6260,
	"./slider/slider4.jpg": 1199,
	"./slider/slider5.jpg": 8818,
	"./space-contentimg.svg": 5033,
	"./space-contentimg1.svg": 5706,
	"./start-icn.svg": 8603,
	"./status-completed-icn.svg": 9449,
	"./status-dwn-arrow.svg": 4284,
	"./status-pending-icn.svg": 9971,
	"./stu-con-hv-icn.svg": 9171,
	"./stu-con-icn.svg": 5702,
	"./students-icn.svg": 1399,
	"./subscription-active-icn.svg": 8517,
	"./subscription-icn.svg": 3236,
	"./tab-minus-icn.svg": 5897,
	"./tab-msg-icn.svg": 5838,
	"./tab-plus-icn.svg": 8513,
	"./testscores-icn.svg": 8738,
	"./tick-blue-icn.svg": 903,
	"./tick-gray-icn.svg": 8198,
	"./tick-green-icn.svg": 1821,
	"./tick-icn.svg": 5076,
	"./tick-square-icn.svg": 8494,
	"./tick-square.svg": 5831,
	"./ticksymbol.svg": 3805,
	"./timeline-white.svg": 2963,
	"./timeline-white2.png": 7091,
	"./univ-slider-img1.png": 4037,
	"./univ-slider-img2.jpg": 3338,
	"./university-icn.svg": 856,
	"./university.png": 4472,
	"./university_banner.png": 9667,
	"./university_logo.png": 4900,
	"./up-arrow-icon.svg": 3629,
	"./up-arrow-white.svg": 6173,
	"./up-arrow.svg": 5865,
	"./uparrow-icn.svg": 2537,
	"./user-icon.svg": 195,
	"./user-img.png": 5455,
	"./visa-icn.svg": 8204,
	"./weight-down.svg": 127,
	"./weight-up.svg": 4528,
	"./whatsapp-icon.png": 5274,
	"./white-arrow-right-circle.svg": 3709,
	"./white-cloud.svg": 7297,
	"./workexperience-icn.svg": 7180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;